module.exports = __webpack_public_path__ + "img/dwdm.5846ca07.png";